import { Stack, Text } from '@mantine/core';
import React from 'react';
import {
  Trans,
  useTranslation
} from 'react-i18next';

const RegistrationSuccess = () => {
  const { t } = useTranslation()
  return (
    <Stack mt="sm" spacing="xs">
      <Text weight="bold">{t('finish.success.subtitle')}</Text>
      <Text>
        <Trans i18nKey="finish.success.text">
          <Text component="a" href={'https://play.google.com/store/apps/details?id=doctor.express.expert'} variant={'link'}>
            Android
          </Text>
          <Text component="a" href={'https://apps.apple.com/ru/app/express-doctor-md/id6471574154'} variant={'link'}>
            Apple iOS
          </Text>
        </Trans>
      </Text>
      <Text>
        {t('finish.success.text2')}
      </Text>
      <Text>
        <Trans i18nKey="finish.success.text3">
          <Text component="a" href={'mailto:doctor@express.doctor'} variant={'link'}>
            doctor@express.doctor
          </Text>
        </Trans>
      </Text>
    </Stack>
  );
};

const RegistrationFailed = () => {
  const { t } = useTranslation()
  return (
    <Stack mt="sm" spacing="xs">
      <Text weight="bold">{t('finish.failure.subtitle')}</Text>
      <Text>
        <Trans i18nKey="finish.failure.text">
          <Text component="a" href={'mailto:doctor@express.doctor'} variant={'link'}>
            doctor@express.doctor
          </Text>
        </Trans>
      </Text>
    </Stack>
  );
};

type RegistrationResultProps = {
  variant: 'success' | 'failure';
};

export const RegistrationResult: React.FC<RegistrationResultProps> = ({ variant }) => {
  return (
    <>
      {variant === 'success' && <RegistrationSuccess />}
      {variant === 'failure' && <RegistrationFailed />}
    </>
  );
};
